import Vue from 'vue';
import Router from 'vue-router';
import { middleware } from './routes/middleware';
import { interceptGuard } from './routes/interceptors';

interceptGuard(Vue);

Vue.use(Router);

const router = new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: () => import(/* webpackPrefetch: true */ './components/layout/RouterRevista.vue'),
      children: [
        {
          path: '',
          name: 'home',
          // component: Home,
          component: () => import(/* webpackPrefetch: true */ './views/revista/Home.vue'),
          meta: {
            isLogin: true,
          },
        },
        {
          path: '',
          name: 'principal',
          component: () => import(/* webpackPrefetch: true */ './views/revista/Noticias.vue'),
          meta: {
            isLogin: true,
          },
          children: [
            {
              name: 'notificacao',
              path: 'notificacao',
              component: () =>
                import(/* webpackPrefetch: true */ './views/revista/Notificacao.vue'),
            },
            {
              name: 'ranking-lojas',
              path: 'ranking-lojas',
              component: () =>
                import(/* webpackPrefetch: true */ './views/revista/RankingLojas.vue'),
            },
            {
              name: 'categoria',
              path: 'categoria/:categoria',
              component: () =>
                import(
                  /* webpackPrefetch: true */ './components/layout/conteudo/BaseCategoria.vue'
                ),
            },
            {
              name: 'favoritos',
              path: 'favoritos',
              component: () => import(/* webpackPrefetch: true */ './views/revista/Favoritos.vue'),
            },
            {
              name: 'tags',
              path: 'tags/:tag',
              component: () =>
                import(/* webpackPrefetch: true */ './components/layout/conteudo/BaseTag.vue'),
            },
            {
              name: 'post',
              path: 'categoria/:categoria/post/:noticia',
              component: () =>
                import(/* webpackPrefetch: true */ './components/layout/conteudo/BasePost.vue'),
            },
            {
              name: 'se-liga',
              path: 'se-liga/:noticia',
              component: () =>
                import(/* webpackPrefetch: true */ './components/layout/conteudo/BasePost.vue'),
            },
          ],
        },
        {
          name: 'vivo.consulta.home',
          path: 'tabela-de-preco',
          component: () =>
            import(/* webpackPrefetch: true */ './views/vivo-consulta/VivoConsulta.vue'),
        },
        {
          name: 'vivo.consulta.page',
          path: 'tabela-de-preco/p/:page/:id',
          component: () =>
            import(/* webpackPrefetch: true */ './views/vivo-consulta/CelularDetalhado.vue'),
        },
        {
          name: 'redirect', 
          path: '/redirect/:link(.*)',
          beforeEnter(to) {
            window.open(to.params.link, '_blank').focus()
            next(false)
          }
        },
      ],
    },
    /**
     * Auth Syscor
     */
    {
      name: 'login-syscor-modulo',
      path: '/login/:modulo/:token',
      component: () => import(/* webpackPrefetch: true */ './views/LoginSyscor.vue'),
      meta: {
        isLogin: false,
      },
    },
    /**
     * Link Temporário
     */
    {
      path: '/shared/:token',
      name: 'shared',
      component: () => import(/* webpackPrefetch: true */ './views/Shared.vue'),
    },
    /**
     * Login Route
     */
    {
      name: 'login',
      path: '/login',
      component: () => import(/* webpackPrefetch: true */ './views/Login.vue'),
    },
    // {
    //   path: '/tabela',
    //   component: () => import('./components/vivo-consulta/VivoConsultaLayout.vue'),
    //   children: [
    //     {
    //       name: 'vivo.tabela.home',
    //       path: '',
    //       component: () =>
    //         import(/* webpackPrefetch: true */ './views/vivo-consulta/VivoConsulta.vue'),
    //     },
    //     {
    //       name: 'vivo.tabela.page',
    //       path: 'p/:page/:id',
    //       component: () =>
    //         import(/* webpackPrefetch: true */ './views/vivo-consulta/CelularDetalhado.vue'),
    //     },
    //     {
    //       name: 'vivo.consulta.celular',
    //       path: 'celular/:id',
    //       component: () =>
    //         import(/* webpackPrefetch: true */ './views/vivo-consulta/CelularDetalhado.vue'),
    //     },
    //     {
    //       path: '*',
    //       redirect: '/404',
    //     },
    //   ],
    // },
    {
      name: '404',
      path: '/404',
      component: () => import(/* webpackPrefetch: true */ './views/NotFound.vue'),
    },
    {
      path: '*',
      redirect: '/404',
    },
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

middleware(router);

export default router;
